// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"53f5c9c6","889":"8261b4bd"}[chunkId] + ".chunk.js";
};